import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _isFunction from 'lodash/isFunction';
import _reduce from 'lodash/reduce';
import _get from 'lodash/get';
import _values from 'lodash/values';
import _assign from 'lodash/assign';
import _castArray from 'lodash/castArray';
import _property from 'lodash/property';

// Constants
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
export var getValueForOption = function getValueForOption(getOptionValue, option) {
  if (_isFunction(getOptionValue)) {
    return getOptionValue(option);
  }
  return option.value;
};

/**
 * Constructs the list of value strings which needs to be added in the onChange payload.
 * Cast array is done as option can both be an object in case of single select and in case of multi select it will be an array.
 * Cast array will make sure no matter the type we are always returning an array of value strings.
 */
export var getOnChangeValue = function getOnChangeValue(getOptionValue, option) {
  if (!option) {
    return EMPTY_ARRAY;
  }
  var optionsArray = _castArray(option);
  return optionsArray.map(function (opt) {
    return getValueForOption(getOptionValue, opt);
  });
};

/**
 * Always returns a static message to show when we are searching/loading options for a particular search query.
 */
export var getLoadingMessage = function getLoadingMessage() {
  return __('Searching...');
};
/**
 * Checks whether a given option is the create new option.
 */
export var isOptionNew = _property('__isNew__');

/**
 * Always returns a static message to show when no options are found for a particular search query.
 */
export var getNoOptionsMessage = function getNoOptionsMessage(_ref) {
  var inputValue = _ref.inputValue;
  return inputValue ? __('No Match Found') : __('Start typing to search');
};
export var getGroupedOptions = function getGroupedOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
  var reduceGroupByLabelObject = _reduce(options, function (result, curr) {
    var newResult;
    var labelValue = _get(curr, 'label');
    var currentOptions = _get(curr, 'options');
    if (result[labelValue]) {
      var oldOptions = _get(result, "".concat(labelValue, ".options"));
      newResult = _assign(result, _defineProperty({}, labelValue, {
        label: labelValue,
        options: [].concat(_toConsumableArray(oldOptions), _toConsumableArray(currentOptions))
      }));
    } else {
      newResult = _assign(result, _defineProperty({}, labelValue, {
        label: labelValue,
        options: currentOptions
      }));
    }
    return newResult;
  }, {});
  return _values(reduceGroupByLabelObject);
};